module.exports = __webpack_public_path__ + "static/media/DurgaIt4.03bda5cb.png";